import React from "react";
import { useLang } from "../context/LangContext";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer
      data-testid="global-footer"
      className="border-t border-border bg-white mt-auto"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
        <div className="text-muted-foreground">
          {t("footer")} <span className="heart-pulse" aria-label="love">♥</span> {t("footerCity")}{" "}
          <a
            data-testid="footer-brand-link"
            href="https://beta-webagentur.de"
            target="_blank"
            rel="noopener noreferrer"
            className="text-foreground font-medium underline-offset-4 hover:underline"
          >
            Beta-Webagentur.de
          </a>
        </div>
        <div className="flex items-center gap-4 text-muted-foreground">
          <Link to="/impressum" data-testid="footer-imprint-link" className="hover:text-foreground">
            {t("nav.impressum")}
          </Link>
          <Link to="/datenschutz" data-testid="footer-privacy-link" className="hover:text-foreground">
            {t("nav.privacy")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
